const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Mark Indent As Delivered',
  description: 'To show mark as delivered button',
  sortOrder: 1,
  name: 'mark_indent_as_delivered',
  documentKey: 'mark_indent_as_delivered',
  values: {
    shipper_mark_as_delivered: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'shipper_mark_as_delivered',
      documentKey: 'shipper_mark_as_delivered',
    },
    delivery_window_days: {
      dataType: NIMBUS_DATA_TYPES.INTEGER,
      defaultValue: 2,
      displayName: 'delivery_window_days',
      documentKey: 'delivery_window_days',
    },
  },
};
